// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Form_wrapper__3nGED","form-list":"Form_form-list__8kcdm","button-group":"Form_button-group__4kACi","submit":"Form_submit__3lXtz"};